import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { ClipLoader } from 'react-spinners';
import { RiRefreshLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import Pagination from '../pagination/pagination';
import { useSelector } from 'react-redux';
import { getUserName, getUserRole } from '../../../Redux/selecters';
import LeaseApiService from '../../services/apiService';
import moment from 'moment';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { useLocation, useNavigate } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const LeaseApproval = () => {
    const [searchTerm, setSearchTerm] = useState({ value: 'Pending', label: 'Pending' });
    const [rowData, setRowData] = useState([]);
    const [loader, setloader] = useState(false);
    const [SupplierTab, setSupplierTab] = useState(true);
    const [POTab, setPOTab] = useState(true);
    const userName = useSelector(getUserName);
    const userRole = useSelector(getUserRole);
    const isPropertyManager = userRole === "PropertyManager" || userRole === " Property Manager" || userRole === "Property Manager" || userRole === "Property Manager ";
    const isAdminOrFinance = userRole === "Admin" || userRole === "FinanceAdmin" || userRole === 'Finance Admin' || userRole === " Finance Admin" || userRole === "Finance Admin ";
    const apiService = new LeaseApiService();
    const [colDefs, setColDefs] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [msgModal, setMsgModal] = useState(false);
    const [discountPopup, setDiscountModal] = useState(false);
    const [currentMsgIndex, setCurrentMsgIndex] = useState(0);
    const [validationItems, setValidationItems] = useState([]);
    const [leaseApprovalTypeList, setLeaseApprovalTypeList] = useState([]);
    const [datamsg, setDatamsg] = useState("");
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [permissions, setPermissions] = useState([])
    const onCloseModal = () => setDiscountModal(false);
    const location = useLocation();
    const navigate = useNavigate();
    const leaseData = location.state;
    const { currencyPrecision } = useCurrency();
    const [contextMenu, setContextMenu] = useState(null)
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const [selectedLease, setSelectedLease] = useState(null);
    const [loading, setLoader] = useState(false);

    useEffect(() => {
        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);
        return () => window.removeEventListener('click', handleClickOutside);
    }, [])
    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Lease Reservation Approval");
        setPermissions(permissions[0]);
    }, [])
    useEffect(() => {
        getItems()
    }, []);
    const [formData, setFormData] = useState({
        leaseNo: "",
        FreeRent: "",
        discountPerc: "",
        discount: "",
        rentPerMonth: 0,
        securityDeposit: 0,
        total: 0,
        afterRentPeriod: 0,
        afterRentMonth: 0,
        rentForPeriod: 0,
        afterSecurityDep: 0
    });
    const onCancelMsg = () => {
        setloader(false)
        setMsgModal(false);
        setValidationItems(null);
        setCurrentMsgIndex(0);
        setSelectedItems(null); // clear selection
        window.location.reload(true);
        toast.info("Action cancelled. Please select items again.");
    };
    const onContinueMsg = () => {
        setMsgModal(false);
        processNextItem(validationItems, currentMsgIndex + 1);
    };
    const StatusFilter = [
        { value: 'Pending', label: 'Pending' },
        { value: 'Approved', label: 'Approved' },
        { value: 'Rejected', label: 'Rejected' },
    ];
    const getMonthsDifference = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const yearsDiff = end.getFullYear() - start.getFullYear();
        const monthsDiff = end.getMonth() - start.getMonth();
        return yearsDiff * 12 + monthsDiff + 1; // +1 to include the current month
    };
    const handleFilter = (selectedOption) => {
        setSearchTerm(selectedOption)
    };
    const dateFormatter = (params) => {
        if (!params.value) return '---';
        const date = moment(params.value);
        return date.isValid() ? date.format("DD-MMM-YYYY") : '---';
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        let value = momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1
        return value || '';
    };
    const getItems = async (newPageNo = pagination?.currentPage) => {
        setLoader(true)
        try {
            let filterType = "Pending"; // Default

            if (leaseData?.leaseNo) {
                if (leaseData?.isApproved === false && leaseData?.isRejected === false) {
                    filterType = "Pending";
                    setSearchTerm({ value: 'Pending', label: 'Pending' });
                } else if (leaseData?.isApproved === true && leaseData?.isRejected === false) {
                    filterType = "Approved";
                    setSearchTerm({ value: 'Approved', label: 'Approved' });
                } else if (leaseData?.isApproved === false && leaseData?.isRejected === true) {
                    filterType = "Rejected";
                    setSearchTerm({ value: 'Rejected', label: 'Rejected' });
                }
            } else {
                filterType = searchTerm?.label || "Pending";
            }

            const isRejected = filterType === 'Rejected';

            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', 20);
            params.append('LoggedInUserId', userName || '');
            params.append('FilterType', filterType);
            params.append('LeaseNo', leaseData?.leaseNo || formData?.leaseNo || "");

            const res = await apiService.getApiParamater('GET_RESERV_APPROVAL', `?${params.toString()}`);
            setRowData(res?.data?.result || [] || null);
            setPagination(res.data.paginationData);

            setColDefs([
                {
                    headerName: '', field: 'recordId', cellRenderer: BtnCellRenderer, pinned: 'left',
                    cellRendererParams: {
                        clicked: function (field, exp2) {
                            handleMenuAction(field, exp2);
                        },
                    }, width: 30,
                },
                {
                    headerName: "Approved",
                    field: "isApproved",
                    editable: false,
                    suppressMovable: true,
                    width: 90,
                    pinned: 'left',
                    cellRenderer: (params) => (
                        <input
                            type="checkbox"
                            className='center'
                            style={{
                                width: "26.81px",
                                height: "26.81px",
                                border: "0.5px solid #7E57C2",
                                cursor: params.data.isRejected ? "not-allowed" : "pointer"
                            }}
                            checked={params.data.isApproved}
                            // disabled={params.data.isRejected === true}
                            disabled={searchTerm?.label === "Rejected"}
                            onChange={(e) =>
                                handleCheckboxChange(
                                    params.data.leaseNo,
                                    'isApproved',
                                    e.target.checked
                                )
                            }
                        />
                    )
                },
                {
                    headerName: "Rejected",
                    field: "isRejected",
                    editable: false,
                    suppressMovable: true,
                    width: 80,
                    pinned: 'left',
                    cellRenderer: (params) => (
                        <input
                            type="checkbox"
                            className='center'
                            style={{
                                width: "26.81px",
                                height: "26.81px",
                                border: "0.5px solid #7E57C2",
                                cursor: params.data.isRejected ? "not-allowed" : "pointer"
                            }}
                            checked={params.data.isRejected}
                            // disabled={params.data.isRejected === true}
                            disabled={searchTerm?.label === "Rejected"}

                            onChange={(e) =>
                                handleCheckboxChange(
                                    params.data.leaseNo,
                                    'isRejected',
                                    e.target.checked
                                )
                            }
                        />
                    )
                },
                {
                    headerName: isRejected ? "Rejected By" : "Approved By",
                    field: "approvedBy",
                    filter: true,
                    floatingFilter: true,
                    suppressMovable: true,
                    width: 150
                },
                {
                    headerName: isRejected ? "Rejected On" : "Approved On", field: "approvedOn", filter: true, floatingFilter: true, valueFormatter: dateFormatter,
                    comparator: dateComparator, suppressMovable: true, width: 150
                },
                { headerName: "Remarks", field: "remarks", editable: true, suppressMovable: true, width: 300 },
                { headerName: "Lease No", field: "leaseNo", filter: true, floatingFilter: true, suppressMovable: true, width: 150 },
                { headerName: "Property Name", field: "propertyName", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
                { headerName: "Unit No", field: "unitNo", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
                { headerName: "Customer No", field: "customerNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
                { headerName: "Customer Name", field: "customerName", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
                {
                    headerName: "Lease Date", field: "leaseDate", filter: true, floatingFilter: true, valueFormatter: dateFormatter,
                    comparator: dateComparator, suppressMovable: true, width: 150
                },
                {
                    headerName: "Lease Expiry", field: "leaseExpiry", filter: true, floatingFilter: true, valueFormatter: dateFormatter,
                    comparator: dateComparator, suppressMovable: true, width: 150
                },
                { headerName: "Type", field: "agreementType", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
                {
                    headerName: "Total Rent", field: "leaseAmount", filter: true, floatingFilter: true, suppressMovable: true, width: 130,
                    valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
                },
                { headerName: "Electric Consumption", field: "electricalConsum", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
                { headerName: "Package", field: "portableWater", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
                { headerName: "Agent", field: "salesPerson", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
                { headerName: "Created By", field: "createdBy", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
                {
                    headerName: "Monthly Rent", field: "monthlyRent", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
                    valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
                },
                {
                    headerName: "Security Deposit", field: "securityDeposit", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
                    valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
                },
            ]);
            setloader(false);
            setLoader(false)
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoader(false)
            // Handle error (e.g., show error message to user)
            setloader(false); // Set loading to false even in case of error
        }
    }
    const handleBackClick = () => {
        window.history.back();
    };
    const handleReset = () => {
        setloader(false);
        setFormData({ leaseNo: '' });
        setSearchTerm({ value: 'Pending', label: 'Pending' });
        navigate(location.pathname, { replace: true, state: null });
    };
    const handleRemarks = (event) => {
        const editedRow = rowData.find(row => row.leaseNo === event.data.leaseNo);
        if (editedRow) {
            editedRow[event.colDef.field] = event.value;

            setSelectedItems(prevItems => {
                const updatedItems = [...prevItems];
                const existingItemIndex = updatedItems.findIndex(item => item.docno === editedRow.leaseNo);

                if (existingItemIndex !== -1) {
                    updatedItems[existingItemIndex] = {
                        ...updatedItems[existingItemIndex],
                        [event.colDef.field]: event.value,
                    };
                } else {
                    updatedItems.push({ ...editedRow });
                }

                return updatedItems;
            });
        }
    };
    const handleCheckboxChange = async (leaseNo, field, isChecked) => {

        const params = new URLSearchParams();
        params.append('Action', 'checkLeaseEditValidation');
        params.append('LeaseNo', leaseNo);
        const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
        let data = res?.data?.result?.data
        if (data?.length === 0) {
            setData(leaseNo, field, isChecked)
        } else {
            if (data?.Invoices === 0 && data?.Receipts === 0) {
                setData(leaseNo, field, isChecked)
            } else if (data?.Invoices > 0 || data?.Receipts > 0) {
                toast.warning("Invoices or Receipts created, Cannot Update Lease Status")
            }
        }
    };
    const setData = (leaseNo, field, isChecked) => {
        setRowData(prevData => {
            return prevData.map(row => {
                if (row.leaseNo === leaseNo) {

                    let updatedRow = {
                        ...row,
                        isUpdated: true
                    };

                    // Approved checkbox
                    if (field === 'isApproved') {
                        updatedRow.isApproved = isChecked;

                        // if approved checked then reject false
                        if (isChecked) {
                            updatedRow.isRejected = false;
                        }
                    }

                    // Rejected checkbox
                    if (field === 'isRejected') {
                        updatedRow.isRejected = isChecked;

                        // if rejected checked then approved false
                        if (isChecked) {
                            updatedRow.isApproved = false;
                        }
                    }

                    // update selected items
                    setSelectedItems(prevItems => {
                        const updatedItems = [...prevItems];

                        const existingIndex = updatedItems.findIndex(
                            item => item.leaseNo === leaseNo
                        );

                        if (existingIndex !== -1) {
                            updatedItems[existingIndex] = updatedRow;
                        } else {
                            updatedItems.push(updatedRow);
                        }

                        return updatedItems;
                    });

                    return updatedRow;
                }

                return row;
            });
        });
    };
    const handleStatusChange = () => {
        setloader(true);

        const selected = selectedItems || [];

        if (selected.length === 0) {
            setloader(false);
            toast.warning("Please select atleast one Reservation");
            return;
        }

        setValidationItems(selected);
        setCurrentMsgIndex(0);

        processNextItem(selected, 0);
    };
    const processNextItem = (items, index) => {
        if (index >= items.length) {
            // Done validating all items, now call API
            const finalList = items.map(item => ({
                leaseNo: item.leaseNo,
                isApproved: item.isApproved || false,
                isRejected: item.isRejected || false,
                approvedBy: userName,
                approvedOn: new Date().toISOString(),
                remarks: item.remarks,
                internalRemarks: "0"
            }));
            setLeaseApprovalTypeList(finalList);
            proceedWithApiCall(finalList);
            return;
        }

        const currentItem = items[index];
        if (currentItem.msg === "0" || currentItem?.msg?.trim() === "" || currentItem?.msg === null) {
            // If no message, go to next item
            processNextItem(items, index + 1);
        } else {
            setCurrentMsgIndex(index);
            setDatamsg(currentItem.msg); // show msg in modal
            setMsgModal(true); // open modal
        }
    };
    const proceedWithApiCall = async (finalList) => {
        // Validate remarks only for rejected items
        const missingRemarks = finalList?.find(
            item => item.isRejected === true && (!item?.remarks || item?.remarks?.trim() === "")
        );

        if (missingRemarks) {
            setloader(false)
            toast.error("Remarks are required for all rejected items.");
            return;
        }

        const body = {
            leaseApprovalTypeList: finalList.map(item => ({
                leaseNo: item.leaseNo,
                isApproved: item.isApproved || false,
                isRejected: item.isRejected || false,
                approvedBy: userName,
                approvedOn: new Date().toISOString(),
                remarks: item.remarks || "0",
                internalRemarks: "0"
            }))
        };

        const response = await apiService.put('UPDATE_RESERV_APPROVAL', body);

        if (response?.data?.statusCode === 201 || response.data.statusCode === 200) {
            toast.success("Updated successfully.");
            getItems();
            setSelectedItems([]);
            setloader(false)
        } else {
            setloader(false)
            toast.error("Something went wrong during update.");
        }
        setloader(false)
    };
    const handleChange = async (e) => {
        const { name, value } = e.target;
        if (name === "discountPerc") {
            const newValue = parseFloat(value) || 0;

            // Admin & FinanceAdmin can enter 0-100%
            if (isAdminOrFinance) {
                if (newValue < 0 || newValue > 100) {
                    toast.warning("Discount % must be between 0 and 100");
                    return;
                }
            }

            // PropertyManager can also enter up to 100
            // but approval logic will be controlled by buttons
            if (isPropertyManager) {
                if (newValue < 0 || newValue > 100) {
                    toast.warning("Discount % must be between 0 and 100");
                    return;
                }
            }
        }

        if (name === "FreeRent") {
            const newValue = parseFloat(value) || 0;
            const rentPerMonth = parseFloat(formData?.rentPerMonth) || 0;

            if (newValue < 0 || newValue > rentPerMonth) {
                toast.warning(
                    `Free Rent amount must be between 0 and ${rentPerMonth}`
                );
                return;
            }
        }


        if (name === "discountPerc") {
            let newvalue = parseFloat(value) || 0;
            let amount = parseFloat(formData?.rentPerMonth) || 0;
            let security = parseFloat(formData?.securityDeposit || 0) || 0;
            // Calculate discount and tax
            let discountAmount = (amount * newvalue) / 100;
            // Calculate total amount
            const totalMonths = getMonthsDifference(selectedLease.leaseDate, selectedLease.leaseExpiry);
            const monthlyRent = (amount - discountAmount);
            const securityDepo = (security - discountAmount);
            const securityDeposit = securityDepo < 0 ? 0 : securityDepo;

            const params = new URLSearchParams();
            params.append('Action', selectedLease?.Category_Mix === "US Navy" ? 'CalculateRentByMonthUSNAVY' : 'CalculateRentByMonth');
            params.append('PeriodFrom', selectedLease.leaseDate);
            params.append('PeriodTo', selectedLease.leaseExpiry);
            params.append('Commontext', monthlyRent);
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            let result = res?.data?.result?.data?.RentPerAnnum;
            let totalAmount = (result + securityDeposit);
            setFormData({
                ...formData,
                total: totalAmount?.toFixed(currencyPrecision?.decimalNumbers || 2),
                discountPerc: newvalue,
                FreeRent: discountAmount?.toFixed(currencyPrecision?.decimalNumbers || 2),
                afterRentMonth: monthlyRent?.toFixed(currencyPrecision?.decimalNumbers || 2),
                afterRentPeriod: result?.toFixed(currencyPrecision?.decimalNumbers || 2),
                afterSecurityDep: securityDeposit?.toFixed(currencyPrecision?.decimalNumbers || 2)
            });
        } else if (name === "FreeRent") {
            let newvalue = parseFloat(value) || 0;
            let amount = parseFloat(formData?.rentPerMonth) || 0;
            let security = parseFloat(formData?.securityDeposit) || 0;
            // Calculate discount percentage
            let discountAmountPerc = amount > 0 ? (newvalue / amount) * 100 : 0;

            const monthlyRent = (amount - newvalue);
            const params = new URLSearchParams();
            params.append('Action', selectedLease?.Category_Mix === "US Navy" ? 'CalculateRentByMonthUSNAVY' : 'CalculateRentByMonth');
            params.append('PeriodFrom', selectedLease.leaseDate);
            params.append('PeriodTo', selectedLease.leaseExpiry);
            params.append('Commontext', monthlyRent);
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            let result = res?.data?.result?.data?.RentPerAnnum;
            const securityDepo = (security - newvalue);
            const securityDeposit = securityDepo < 0 ? 0 : securityDepo;
            let totalAmount = (result + securityDeposit);
            setFormData({
                ...formData,
                total: totalAmount?.toFixed(currencyPrecision?.decimalNumbers || 2),
                discountPerc: discountAmountPerc?.toFixed(2),
                FreeRent: newvalue,
                afterRentMonth: monthlyRent?.toFixed(currencyPrecision?.decimalNumbers || 2),
                afterRentPeriod: result?.toFixed(currencyPrecision?.decimalNumbers || 2),
                afterSecurityDep: securityDeposit?.toFixed(currencyPrecision?.decimalNumbers || 2)
            });
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    };
    const handleDiscount = async (rowData) => {
        if (rowData) {
            const rowIndex = rowData.rowIndex ?? rowData.node?.rowIndex;

            setSelectedRowIndex(rowIndex);
            setSelectedLease(rowData)

            const param = new URLSearchParams();
            param.append('Action', 'GetReservationDiscountDetailsByLeaseNo');
            param.append('LeaseNo', rowData?.leaseNo || 'All');
            const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${param.toString()}`);
            let data = res?.data?.result?.data

            setFormData({
                rentForPeriod: rowData.leaseAmount || 0,
                discountPerc: data?.NewDiscountPercent || 0,
                FreeRent: data?.NewDiscountAmount || 0,
                rentPerMonth: rowData?.monthlyRent || 0,
                securityDeposit: rowData?.securityDeposit || 0,
                afterRentMonth: data?.RentPerMonth || 0,
                afterSecurityDep: data?.Security_Deposit || 0,
                total: (parseInt(data?.TotalPeriodRent) + parseInt(data?.Security_Deposit)).toFixed(currencyPrecision?.decimalNumbers || 2) || 0,
                afterRentPeriod: data?.TotalPeriodRent || 0,
            });
            setDiscountModal(true);
        }
    };
    const handleMenuAction = (action, rowData) => {
        if (action === 'edit') {
            handleDiscount(rowData);
        }
        setContextMenu(null); // Close the menu
    }
    const handleOkDiscount = async () => {
        if (selectedRowIndex === null) return;
        const updatedData = [...rowData];
        if (formData.discountPerc === 0 || formData.FreeRent === 0) {
            toast.warning("Enter Discount Amount")
            return
        }
        updatedData[selectedRowIndex] = {
            ...updatedData[selectedRowIndex],
            leaseAmount: formData.total,   // updated value
            discountPerc: formData.discountPerc,
            FreeRent: formData.FreeRent,
            isApproved: true,
            monthlyRent: formData?.afterRentMonth,
            securityDeposit: formData?.afterSecurityDep,
        };

        let body = {
            updateRentData: {
                leaseNo: selectedLease?.leaseNo,
                nSecurityDeposit: (formData?.afterSecurityDep).toString(),
                nTotalPrice: (formData?.afterRentPeriod).toString(),
                nTotalPriceByUser: (formData.afterRentPeriod).toString(),
                nDiscountAmount: (formData.FreeRent).toString(),
                nDiscountPercent: (formData.discountPerc).toString(),
                nExp12: (formData?.afterRentMonth).toString(),
                nExp13: (formData?.afterRentMonth).toString(),
            }
        }

        const response = await apiService.put('UPDATE_RENT', body);
        if (response?.data?.statusCode === 200 || response?.data?.statusCode === 201) {

            proceedWithApiCall(updatedData)
            setRowData(updatedData);
            setDiscountModal(false);
        }
    };
    const HandlePutHigherApproval = async () => {

        // if (selectedRowIndex === null) return;
        const updatedData = [...rowData];
        if (formData.discountPerc === 0 || formData.FreeRent === 0) {
            toast.warning("Enter Discount Amount")
            return
        }
        let body = {
            assignToHigher: {
                leaseNo: selectedLease?.leaseNo || "0",
                nSecurityDeposit: formData?.afterSecurityDep.toString() || "0",
                nTotalPrice: formData?.afterRentPeriod.toString() || "0",
                nTotalPriceByUser: formData?.afterRentPeriod.toString() || "0",
                nDiscountAmount: formData?.FreeRent.toString() || "0",
                nDiscountPercent: formData?.discountPerc.toString() || "0",
                nExp12: formData?.afterRentMonth.toString() || "0",
                nExp13: formData?.afterRentMonth.toString() || "0"
            }
        }

        const response = await apiService.put('PUT_HEIGHER_APPROVAL', body);
        if (response?.data?.statusCode === 200 || response?.data?.statusCode === 201) {
            // proceedWithApiCall(updatedData)
            setRowData(updatedData);
            setDiscountModal(false);
            getItems()
            toast.success("Sent to Higher Authority successfully")
        }
    };
    const discountPerc = parseFloat(formData.discountPerc) || 0;
    const canApprove = isAdminOrFinance || (isPropertyManager && discountPerc <= 5);
    const canSendHigherAuthority = isPropertyManager && discountPerc > 5;
    return (
        <div className='p-3'>
            <div className="cost-center-section">
                <div className="d-flex cursor-pointer gap-3 slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='param-label pt-1'>Lease Approvals</div>
                    <IoIosArrowForward
                        size={30}
                        className={`arrow fade-rotate ${POTab ? "open" : ""}`}
                    />
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="pb-3 row">
                            <div className="d-flex col-4 align-items-center">
                                <label className="form-label pt-1">Filter:</label>
                                {StatusFilter.map((status) => (
                                    <div key={status.value} className="form-check mx-2">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="statusFilter"
                                            id={status.value}
                                            value={status.value}
                                            checked={searchTerm.value === status.value}
                                            onChange={() => handleFilter(status)}
                                        />
                                        <label className="form-check-label" htmlFor={status.value}>
                                            {status.label}
                                        </label>
                                    </div>
                                ))}
                            </div>
                            <div className='col-2'>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="leaseNo" placeholder='Enter Lease No'
                                    value={formData.leaseNo}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-6 d-flex gap-2'>
                                {loading === true ?
                                    <div
                                        className='mainbtnGry  center w-25'>
                                        <ClipLoader color="#ffffff" size={25} />
                                    </div> :
                                    <div
                                        onClick={() => getItems()}
                                        className='mainbtnGry flex-end gap-2 w-25'>
                                        <FaFileCircleExclamation color='#fff' className='center mt-2 mx-2' />
                                        <div className='center'>Search</div>
                                    </div>
                                }
                                {loader === true ?
                                    <div
                                        className='mainbtn  center w-25'>
                                        <ClipLoader color="#ffffff" size={25} />
                                    </div> :
                                    <>{permissions?.canAdd === true ?
                                        <div
                                            onClick={() => handleStatusChange()}
                                            className='mainbtn flex-end gap-2  w-25'>
                                            <FaSave color='#fff' className='center mt-2 mx-2' />
                                            <div className='center'>Save</div>
                                        </div> : ""}</>
                                }
                                <div
                                    onClick={() => handleReset()}
                                    className='mainbtnRed flex-end gap-2  w-25'>
                                    <RiRefreshLine color='#fff' className='center mt-2 mx-2' />
                                    <div className='center'>Reset</div>
                                </div>
                                <div
                                    onClick={() => handleBackClick()}
                                    className='mainbtn flex-end gap-2  w-25'>
                                    <FaAngleLeft color='#fff' className='center mt-2 mx-2' />
                                    <div className='center'>Back</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 gap-3 cursor-pointer slide-header"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='param-label pt-1'>Approval List</div>
                    <IoIosArrowForward
                        size={30}
                        className={`arrow fade-rotate ${SupplierTab ? "open" : ""}`}
                    />
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 ${SupplierTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="ag-theme-quartz" style={{ height: 500, suppressMovable: true, width: '100%' }}>
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={colDefs}
                                onCellValueChanged={handleRemarks}
                                suppressRowClickSelection={true}
                                context={{ setContextMenu }}
                                getRowStyle={(params) => {
                                    return params.node.rowIndex % 2 === 0
                                        ? { background: '#F0EDF5' }
                                        : { background: '#fff' };
                                }}
                            />
                        </div>
                        <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
                    </div>
                </div>
            </div>
            <Modal size="md"
                show={msgModal}
                onHide={() => setMsgModal(false)}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title className='center'>{datamsg}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Do you want to continue?</p>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCancelMsg}>Cancel</button>
                    <button className='mainbtnRed' onClick={onContinueMsg}>Ok</button>
                </Modal.Footer>
            </Modal>
            <Modal size="lg"
                show={discountPopup}
                onHide={() => setDiscountModal(false)}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title className='center'>Discount</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-between align-items-center border rounded p-3 mb-3 bg-light">
                        <div>
                            <span className="fw-bold">Property Name:</span>{" "}{" "}
                            <span className="fw-medium">{selectedLease?.propertyName || "-"}</span>
                        </div>
                        <div>
                            <span className="fw-bold">Unit No:</span>{" "}{" "}
                            <span className="fw-medium">{selectedLease?.unitNo || "-"}</span>
                        </div>

                        <div>
                            <span className="fw-bold">Lease No:</span>{" "}{" "}
                            <span className="fw-medium">{selectedLease?.leaseNo || "-"}</span>
                        </div>
                    </div>
                    <div className="form-group ">
                        <div className="d-flex gap-2 my-2">
                            <div className="d-flex gap-2 w-50">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent/Month</label>
                                <input type="number" className="p-2 form-control" name="discountPerc" value={formData.rentPerMonth?.toFixed(currencyPrecision?.decimalNumbers)} disabled />
                            </div>
                            <div className="d-flex gap-2 w-50">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Security Deposit</label>
                                <input type="number" className="p-2 form-control" name="FreeRent" placeholder="0.000" value={formData.securityDeposit?.toFixed(currencyPrecision?.decimalNumbers)} disabled />
                            </div>
                        </div>
                        <div className="d-flex gap-2 my-2">
                            <div className="d-flex gap-2 w-50">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent For period</label>
                                <input type="number" className="p-2 form-control" name="rentForPeriod" value={formData.rentForPeriod?.toFixed(currencyPrecision?.decimalNumbers)} disabled />
                            </div>
                            <div className="d-flex gap-2 w-50">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Total</label>
                                <input type="number" className="p-2 form-control" name="rentForPeriod" value={(formData.rentForPeriod + formData?.securityDeposit)?.toFixed(currencyPrecision?.decimalNumbers)} disabled />
                            </div>
                        </div>
                        <div className="d-flex gap-2 my-2">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Free Rent % / Amount</label>
                            <input type="number" className="p-2 form-control w-50" name="discountPerc" placeholder="%" value={formData.discountPerc} onChange={handleChange} />
                            <input type="number" className="p-2 form-control w-50" name="FreeRent" placeholder="0.000" value={formData.FreeRent} onChange={handleChange} />
                        </div>
                        {formData.afterRentMonth ?
                            <>
                                <div className="d-flex gap-2 my-2">
                                    <div className="d-flex gap-2 w-50">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent/Month after Disc</label>
                                        <input type="number" className="p-2 form-control " name="discountPerc" disabled placeholder="%" value={formData.afterRentMonth} onChange={handleChange} />
                                    </div>
                                    <div className="d-flex gap-2 w-50">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent/Period after Disc</label>
                                        <input type="number" className="p-2 form-control " name="FreeRent" disabled placeholder="0.000" value={formData.afterRentPeriod} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="d-flex gap-2 my-2">
                                    <div className="d-flex gap-2 w-50">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Security Dep after Disc</label>
                                        <input type="number" className="p-2 form-control " name="FreeRent" disabled placeholder="0.000" value={formData.afterSecurityDep} onChange={handleChange} />
                                    </div>
                                    <div className="d-flex gap-2 w-50">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Total after Disc</label>
                                        <input type="text" className="p-2 form-control " name="total" value={formData?.total} disabled />
                                    </div>
                                </div>
                            </>
                            : ""}
                    </div>
                </Modal.Body>
                <Modal.Footer className='p-3 d-flex' style={{ justifyContent: 'space-between' }}>
                    <button
                        className="mainbtn"
                        disabled={!canSendHigherAuthority}
                        style={{
                            cursor: canSendHigherAuthority ? "pointer" : "not-allowed",
                        }}
                        onClick={
                            canSendHigherAuthority
                                ? HandlePutHigherApproval
                                : undefined
                        }
                    >
                        Forward to Higher Authority
                    </button>
                    <div className='d-flex gap-3'>
                        <button className='mainbtnGry' onClick={onCloseModal}>Cancel</button>
                        <button
                            className="mainbtnRed"
                            disabled={!canApprove}
                            style={{
                                cursor: canApprove ? "pointer" : "not-allowed",
                            }}
                            onClick={canApprove ? handleOkDiscount : undefined}
                        >
                            Update & Approve
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            {contextMenu && (
                <div
                    style={{
                        position: 'absolute',
                        top: contextMenu.mouseY,
                        left: contextMenu.mouseX,
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        zIndex: 1000,
                        padding: '10px 30px',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 6px rgba(0,0,0,0.2)'
                    }}
                >
                    <div style={{ display: 'grid' }}>
                        {contextMenu?.data?.isApproved === true ? (
                            "No Option"
                        ) : (
                            (userRole === "Admin" ||
                                userRole === "FinanceAdmin" || userRole === "Finance Admin" || userRole === " Finance Admin" || userRole === "Finance Admin " ||
                                userRole === "PropertyManager" || userRole === " Property Manager" || userRole === "Property Manager" || userRole === "Property Manager ") && (
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => handleMenuAction("edit", contextMenu.data)}
                                >
                                    Discount
                                </button>
                            )
                        )}
                    </div>
                </div>
            )}
        </div >
    )
}

class BtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.stopPropagation();
        const { context, data, node } = this.props;
        if (context && context.setContextMenu) {
            context.setContextMenu({
                mouseX: e.pageX,
                mouseY: e.pageY,
                data: { ...data, rowIndex: node.rowIndex } // ✅ pass index
            });
        }
    }

    render() {
        return (
            <div className='center '>
                <span onClick={this.handleClick} style={{ cursor: 'pointer', fontSize: '30px' }}>
                    &#8942; {/* Vertical Ellipsis */}
                </span>
            </div>
        );
    }
}
export default LeaseApproval;
